/** Вкладки подань над списком (прототип v4 viewTabs): власні подання списку записів першими, далі стандартні подання типу без панелі показників. */
import type { IRecordTypeDefinition, StandardViewKey, ViewKey } from '@platform/core/types';
import { standardViews } from '../viewLabel';

/** Подання, що в прототипі живуть сторінками модуля (Аналітика) чи лівим меню, а не вкладками. */
const NOT_TABS: readonly StandardViewKey[] = ['dashboard'];

/**
 * Види власних подань, що показують записи списку, а не окремий аналіз (прототип v4: каталог VIEWS має «library» — домашню бази знань — серед
 * подань записів, а зал засідань, матриці, трасування й навантаження — окремі сторінки модуля в лівому меню).
 */
const RECORD_VIEW_KINDS: readonly string[] = ['library'];

/** Власні подання типу, що є вкладками перед стандартними (у порядку визначення): «Бібліотека» бази знань. Чиста функція. */
export function customTabViewsOf(rt: IRecordTypeDefinition): string[] {
  return (rt.views.custom ?? []).filter((v) => RECORD_VIEW_KINDS.includes(rt.views.settings?.[v]?.insight?.kind ?? ''));
}

/**
 * Вкладки в порядку перемикача (чиста функція): власні подання списку записів (customTabViewsOf) першими, далі увімкнені в метаданих типу
 * стандартні подання + календар (є завжди, як у прототипі); «Етапи» — лише коли в типу більше одного статусу; без панелі показників (сторінка
 * «Аналітика») і власних аналітичних подань (сторінки модуля).
 */
export function tabViewsOf(rt: IRecordTypeDefinition): ViewKey[] {
  const enabled = new Set<string>([...rt.views.enabled, 'calendar']);
  const standard = standardViews.filter((v) => !NOT_TABS.includes(v) && enabled.has(v) && (v !== 'stages' || rt.statuses.list.length > 1));
  return [...customTabViewsOf(rt), ...standard];
}
